<template>
  <div class="aiz-user-sidenav-wrap position-relative z-1 shadow-sm">
    <div
      class="aiz-user-sidenav overflow-auto c-scrollbar-light pb-5 pb-xl-0"
    >
      <div
        class="fs-14 p-2 py-3 border-bottom bg-primary text-white position-relative d-flex"
      >
        <div class="text-center mr-2">
          <span class="avatar avatar-md mb-2">
            <img
              :src="
                getFileViewUrl(userInfo.photo) ||
                  '/static/assets/img/avatar-place.png'
              "
              alt
              class="image rounded-circle"
            />
          </span>
          <div class="opacity-60" v-if="`,${paramMapAll['SHOP_BUYER_SIDEBAR_CONTENT']},`.includes(',vip,')">{{ userLevel.name }}</div>
          <div class="opacity-60" v-if="!`,${paramMapAll['SHOP_BUYER_SIDEBAR_CONTENT']},`.includes(',vip,')">{{ userInfo.username }}</div>
        </div>
        <van-row>
          <van-col v-if="`,${paramMapAll['SHOP_BUYER_SIDEBAR_CONTENT']},`.includes(',nickName,')" :span="24" class="text-truncate fs-16">
            <div class="">{{ userInfo.nickName }}</div>
          </van-col>
          <van-col v-if="`,${paramMapAll['SHOP_BUYER_SIDEBAR_CONTENT']},`.includes(',vip,')" :span="24" class="text-truncate opacity-60">
            <div class="">{{ userInfo.username }}</div>
          </van-col>
          <van-col :span="24" v-if="`,${paramMapAll['SHOP_BUYER_SIDEBAR_CONTENT']},`.includes(',credit,')" class="text-truncate opacity-60">
            {{ $t("信用分") }}: {{ userMoney.credit }}
          </van-col>
          <van-col :span="24" v-if="`,${paramMapAll['SHOP_BUYER_SIDEBAR_CONTENT']},`.includes(',balance,')" class="text-truncate opacity-60">
            {{ $t("余额") }}: {{ formatMoney(userMoney.balance) }}
          </van-col>
          <van-col :span="24" v-if="`,${paramMapAll['SHOP_BUYER_SIDEBAR_CONTENT']},`.includes(',balance2,')" class="text-truncate opacity-60">
            {{ $t("佣金") }}: {{ formatMoney(userMoney.balance2) }}
          </van-col>
        </van-row>
        <div class="d-flex align-center justify-center" @click="refreshBalance">
          <i class="el-icon-refresh-right u-font-25 opacity-60 u-m-r-10" :class="{'rotate': isLoading}" />
        </div>
      </div>
      <div class="d-flex" style="justify-content: space-around;">
        <van-button v-if="`,${paramMapAll['SHOP_BUYER_SIDEBAR_CONTENT']},`.includes(',recharge,')" class="text-truncate opacity-60" @click="$store.commit('common/SET_accountPanelShow', false);goto(`/user/wallet?option=recharge&t=${new Date().getTime()}`)">
         {{ $t('充值') }}
        </van-button>
        <van-button v-if="`,${paramMapAll['SHOP_BUYER_SIDEBAR_CONTENT']},`.includes(',withdraw,')" class="text-truncate opacity-60" @click="$store.commit('common/SET_accountPanelShow', false);goto(`/user/wallet?option=withdraw&t=${new Date().getTime()}`)">
          {{ $t('提现') }}
        </van-button>
      </div>
      <div class="sidemnenu mb-3">
        <ul class="aiz-side-nav-list px-2 metismenu">
          <li class="aiz-side-nav-item">
            <a
              class="aiz-side-nav-link"
              href="javascript:void(0)"
              @click="goto('/user/dashboard')"
            >
              <i class="las la-home aiz-side-nav-icon"></i>
              <span class="aiz-side-nav-text">{{ $t("首页") }}</span>
            </a>
          </li>

          <li class="aiz-side-nav-item">
            <a
              class="aiz-side-nav-link"
              href="javascript:void(0)"
              @click="goto('/user/purchase_history')"
            >
              <i class="las la-file-alt aiz-side-nav-icon"></i>
              <span class="aiz-side-nav-text">{{ $t("购买历史") }}</span>
            </a>
          </li>
          <li class="aiz-side-nav-item">
            <a
              class="aiz-side-nav-link"
              href="javascript:void(0)"
              @click="goto('/user/wishlists')"
            >
              <i class="la la-heart-o aiz-side-nav-icon"></i>
              <span class="aiz-side-nav-text">{{ $t("愿望清单") }}</span>
            </a>
          </li>

          <li class="aiz-side-nav-item">
            <a
              class="aiz-side-nav-link"
              href="javascript:void(0)"
              @click="goto('/user/compare')"
            >
              <i class="la la-refresh aiz-side-nav-icon"></i>
              <span class="aiz-side-nav-text">{{ $t("对比") }}</span>
            </a>
          </li>

          <li class="aiz-side-nav-item">
            <a
              class="aiz-side-nav-link"
              href="javascript:void(0)"
              style="align-items: center"
              @click="goto('/user/conversations')"
            >
              <el-badge class="item" :is-dot="false" style="display: initial;" :value="chatUnread?chatUnread:null">
                <i class="las la-comment aiz-side-nav-icon"></i>
              </el-badge>
<!--              <i v-else class="las la-comment aiz-side-nav-icon"></i>-->
              <span class="aiz-side-nav-text">{{ $t("对话") }}</span>
              <span
                id="conversations"
                class="badge badge-danger badge-circle badge-sm badge-dot"
                style="display: none"
              >
              </span>
            </a>
          </li>

          <li class="aiz-side-nav-item">
            <a
              class="aiz-side-nav-link"
              href="javascript:void(0)"
              @click="goto('/user/wallet')"
            >
              <i class="las la-dollar-sign aiz-side-nav-icon"></i>
              <span class="aiz-side-nav-text">{{ $t("我的钱包") }}</span>
            </a>
          </li>

          <li class="aiz-side-nav-item">
            <a
              class="aiz-side-nav-link"
              href="javascript:void(0)"
              @click="goto('/user/transaction')"
            >
              <i class="las la-lock aiz-side-nav-icon"></i>
              <span class="aiz-side-nav-text">{{ $t("提款密码") }}</span>
            </a>
          </li>

          <li class="aiz-side-nav-item">
            <a
              class="aiz-side-nav-link"
              href="javascript:void(0)"
              @click="goto(`/user/profile?t=${new Date().getTime()}`)"
            >
              <i class="las la-cog aiz-side-nav-icon"></i>
              <span class="aiz-side-nav-text">{{ $t("管理个人资料") }}</span>
            </a>
          </li>
          <li class="aiz-side-nav-item">
            <a
              class="aiz-side-nav-link"
              href="javascript:void(0)"
              @click="goto('/user/profile?option=userBankCard')"
            >
              <i class="las la-wallet aiz-side-nav-icon"></i>
              <span class="aiz-side-nav-text">{{ $t("提款银行卡") }}</span>
            </a>
          </li>
          <li class="aiz-side-nav-item">
            <a
              class="aiz-side-nav-link"
              href="javascript:void(0)"
              @click="goto('/user/profile?option=userAddress')"
            >
              <i class="las la-map-marker aiz-side-nav-icon"></i>
              <span class="aiz-side-nav-text">{{ $t("收货地址") }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="fixed-bottom d-xl-none bg-white border-top d-flex justify-content-between px-2"
      style="box-shadow: 0 -5px 10px rgb(0 0 0 / 10%)"
    >
      <a
        class="btn btn-sm p-2 d-flex align-items-center"
        href="javascript:void(0)"
        @click="logout"
      >
        <i class="las la-sign-out-alt fs-18 mr-2"></i>
        <span>{{ $t("登出") }}</span>
      </a>
      <button class="btn btn-sm p-2">
        <i class="las la-times la-2x" @click="$store.commit('common/SET_accountPanelShow', false)"></i>
      </button>
    </div>
  </div>
</template>
<script>
import store from "@/store";

import { isLogin } from "@/utils/auth";
export default {
  name: "AccountOpes",
  computed: {
    ...Vuex.mapGetters([
      "paramMapAll",
      'chatUnread',
      'chatGroupLastChange',
      'chatGroupRecord',
    ]),
  },
  data() {
    return {
      isLoading: false
    }
  },
  created() {
    if (this.userInfo && this.userInfo.id) {
      this.$store.dispatch("user/getUserMoney")
    }
    if (this.paramMapAll["SYSTEM_VERSION"] === 'B78' && isLogin())
    this.intervalId = setInterval(() => {
      this.$store.dispatch("user/getUserMoney")
    }, 5000);
  },
  destroyed(){
    clearInterval(this.intervalId)
  },
  methods: {
    async refreshBalance() {
      this.isLoading = true
      await this.$store.dispatch("user/getUserMoney")
      await this.$store.dispatch("user/initSocket");
      this.$toast.success(this.$t('刷新成功'))
      this.isLoading = false
    }
  }
};
</script>
